module.exports = __webpack_public_path__ + "static/media/bursts_05.8cc78f11.svg";